<template>
	<action-card
		v-if="meetings.length"
		:title="$t('nav.meetings')"
		icon="users-round"
		:count="meetings.length"
		@open="$router.push('/meetings/booked')"
	>
		<button
			v-for="meeting in visibleMeetings"
			:key="meeting.id"
			type="button"
			class="portal-action-row"
			@click="openScheduledMeeting(meeting)"
		>
			<span class="action-row-copy">
				<strong>{{ meeting.meetingName }}</strong>
				<small>
					{{ $t('global.on') }}
					{{ DateTime.fromISO(meeting.confirmedTime.start).toFormat('MMM dd @ hh:mma') }}
				</small>
			</span>
			<portal-icon name="chevron-right" :size="18"></portal-icon>
		</button>
	</action-card>
</template>

<script>
	import MeetingDetail from '@/modules/meetings/MeetingDetail';
	import { DateTime } from 'luxon';
	import ActionCard from '@/modules/welcome/actionItems/ActionCard';

	export default {
		name: 'Meetings',

		props: ['meetings'],

		components: { ActionCard },

		data() {
			return { DateTime };
		},

		methods: {
			openScheduledMeeting(meeting) {
				this.$store.state.globalModalController
					.openModal(MeetingDetail, { scheduledMeeting: meeting }, true, false, 'right-panel')
					.then((result) => {
						if (result) this.$emit('refresh');
					});
			},
		},

		computed: {
			visibleMeetings() {
				return this.meetings.slice(0, 5);
			},
		},
	};
</script>
